import {AbstractModel} from './abstract-model';
import {Advertiser} from './advertiser';
import {Document} from './document';

export class Product extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  advertiser: Advertiser | null = null;
  type: string | null = null;
  domain: string | null = null;
  enabled: boolean | null = null;
  identifier: string | null = null;
  logo: Document | null = null;
  cross: boolean = false;
  coreg: boolean = false;
  languages: string[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    this.languages?.sort();

    if (input.advertiser) {
      this.advertiser = new Advertiser().deserialize(input.advertiser);
    }

    if (input.logo) {
      this.logo = new Document().deserialize(input.logo);
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
